import { Badge } from '@/components/ui/Badge';

const classificationMap: Record<string, { variant: 'success' | 'warning' | 'error' | 'info' | 'purple' | 'default'; label: string }> = {
  support: { variant: 'warning', label: 'Support' },
  sales: { variant: 'success', label: 'Sales' },
  partnership: { variant: 'purple', label: 'Partnership' },
  invoice: { variant: 'info', label: 'Invoice' },
  legal: { variant: 'error', label: 'Legal' },
  spam: { variant: 'default', label: 'Spam' },
  urgent: { variant: 'error', label: 'Urgent' },
  general: { variant: 'default', label: 'General' },
};

interface Props {
  classification: string;
}

export function EmailClassificationBadge({ classification }: Props) {
  const config = classificationMap[classification] || { variant: 'default' as const, label: classification };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
